import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteVehicleData, getVehicleList } from "../../redux/actions/VehicleActions";
import RoundedPagination from "../../Components/Paginate";
import FormInput from "../../Components/FormInput";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from '../../util/generalUtills'
import { getCurrentBookingList } from "../../redux/actions/BookingActions";
import Preloader from "../../Components/Preloader";



const Dashboard = ({ status, title }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors, loading },
    bookingReducer: {
      currentBookingList,
      currentBookingCount,
      currentBookingPermissions,
      loadingBooking,
      errorsBooking,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(100);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  // useEffect(() => {
  //   dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
  // }, [auth, paginate, page, search, sort]);

  const fetchDataList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getCurrentBookingList(auth?.accessToken, paginate, page, search, sort, status));
    }
  }, [auth?.accessToken, paginate, page, search, sort, dispatch]);

  useDebounce(fetchDataList, 500, [auth, paginate, page, search, sort, status]);

  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors])


  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? currentBookingCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteVehicleData(auth?.accessToken, id))
        }
      });
  };


  // useEffect(() => {
  //   if(changedVehicleStatus.status)
  //   {
  //     swal.fire({
  //       show: true,
  //       title: "Deleted!",
  //       text: changedVehicleStatus.message,
  //       icon: "success",
  //       showConfirmButton: false,
  //       timer: 1500
  //     });
  //     dispatch({ type: 'RESET_DELETE_STATUS' });
  //     dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
  //   }

  // },[changedVehicleStatus])

  useEffect(() => {
    if (errorsBooking?.status == 401) {
      dispatch(logout())
      toast.error(errors?.data?.message);
      navigate('/login');
      //window.location.reload();
    }
    else if (errorsBooking?.status == 400) {
      //dispatch({ type: 'RESET_DELETE_STATUS' });
    }
  }, [errorsBooking])

  const tableRef = useRef();

  const getRowClass = (status) => {
    switch (status) {
      case "WAITING FOR DRIVER":
        return "bg-light"; // Light gray
      case "DRIVER ASSIGNED":
        return "bg-primary-subtle"; // Light blue
      case "ACCEPT":
        return "bg-warning-subtle"; // Light yellow
      case "REQUEST FOR OPEN VALVE":
      case "OPENING VALVE":
      case "CLOSING VALVE":
        return "bg-secondary-subtle"; // Light gray
      case "OPEN VALVE":
      case "CLOSE VALVE":
        return "bg-info-subtle"; // Light cyan
      case "REACHED HYDRANT":
        return "bg-danger-subtle"; // Light red
      case "ON GOING":
        return "bg-success-subtle"; // Light green
      case "Water Supply Start":
        return "bg-info-subtle"; // Light cyan
      case "Water Supply End":
        return "bg-pink-subtle"; // Light pink
      case "P COMPLETE":
        return "bg-blue-subtle"; // Light blue
      case "COMPLETE":
        return "bg-secondary-subtle"; // Light gray
      default:
        return ""; // Default row color
    }
  };


  const getBadgeClass = (status) => {
    switch (status) {
      case "WAITING FOR DRIVER":
        return "badge-outline-dark";
      case "DRIVER ASSIGNED":
        return "badge-outline-primary";
      case "ACCEPT":
        return "badge-outline-warning";
      case "REQUEST FOR OPEN VALVE":
      case "OPENING VALVE":
      case "CLOSING VALVE":
        return "badge-outline-secondary";
      case "OPEN VALVE":
      case "CLOSE VALVE":
        return "badge-outline-blue";
      case "REACHED HYDRANT":
        return "badge-outline-danger";
      case "ON GOING":
        return "badge-outline-success";
      case "Water Supply Start":
        return "badge-outline-info";
      case "Water Supply End":
        return "badge-outline-pink";
      case "P COMPLETE":
        return "badge-outline-blue";
      case "COMPLETE":
        return "badge-outline-secondary";
      default:
        return "";
    }
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: title, path: "/Current Job", active: true },
        ]}
        title={`${title}`}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(currentBookingPermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center">
                          <input
                            type="search"
                            placeholder="Search..."
                            className="form-control ms-1"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        <Button variant="success" onClick={fetchDataList}>
                          <i className="mdi mdi-clipboard-plus-outline me-1"></i>Refresh
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ overflowY: 'auto', maxHeight: '500px', border: "1px solid #dee2e6" }}>
                <Table ref={tableRef} className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>SR No.</th>
                      <th>Job Id</th>
                      <th>Number<br />Name</th>
                      <th>Booking Time</th>
                      <th>Vehicle</th>
                      <th>Hydrant</th>
                      <th>Drop Location</th>
                      <th>Booked By / Date Time</th>
                      <th>Assigned By / Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBookingList.length === 0 ? (
                      <tr>
                        <td colSpan="6">No data found</td>
                      </tr>
                    ) : (<>
                      {currentBookingList?.map?.((item, index) => {
                        return (
                          <tr key={item.id} className={getRowClass(item?.taxiStatus)}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                            <td>{item?.bookingId}</td>
                            <td>{item?.name}<br />{item?.mobile}<br />{item?.bookingType}</td>
                            <td>{getDisplayDateTimeFormat(item?.bookingDate)}</td>
                            <td>
                              {(currentBookingPermissions?.edit) && (
                                <>
                                  {item?.vehicle?.vehicleNumber ? (
                                    <>
                                      {item?.vehicle?.vehicleNumber} <br />{item?.driverName}<br />{item?.driverMobile}
                                      {auth?.roleCode === "JUNIOR_ENGINEER" && (
                                        <Link to={`/Assign-Vehicle-Booking/${item?.id}`}>
                                          <Badge bg="" className="badge-outline-dark">{t("Change/Cancel Trip")}</Badge>
                                        </Link>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {auth?.roleCode === "JUNIOR_ENGINEER" ? (
                                        <Link to={`/Assign-Vehicle-Booking/${item?.id}`}>
                                          <Badge bg="" className="badge-outline-dark">{t("Assign Vehicle")}</Badge>
                                        </Link>
                                      ) : (
                                        <span style={{ color: 'red' }}>Contact J.E.N. For booking assign</span>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </td>
                            <td>{item?.hydrantName}</td>
                            <td>{item?.destinationName}</td>
                            <td>{item?.createdBy?.name}<br />{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>{item?.assignBy?.name}<br />{getDisplayDateTimeFormat(item?.assignAt)}</td>
                            <td>
                              <Badge bg="" className={getBadgeClass(item?.taxiStatus)} key={index}>
                                {item?.taxiStatus}
                              </Badge>
                            </td>
                          </tr>

                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">

                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option selected value="100">100</option>
                    <option value="500">500</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(currentBookingCount / paginate)}</strong> </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(currentBookingCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />


              </div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingBooking && (<Preloader />)}

    </>
  );
};

export default Dashboard;
